import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookCurrencyInputWrapper } from 'src/components/CookbookCurrencyInputWrapper/CookbookCurrencyInputWrapper';

export interface MaxInvoiceAmountProps {
  name: string;
  id: string;
}

export function MaxInvoiceAmountControl({
  name,
  id,
}: MaxInvoiceAmountProps): JSX.Element {
  const { errors, control } = useFormContext();

  return (
    <CookbookCurrencyInputWrapper
      currency="USD"
      locale="en-US"
      name={name}
      id={id}
      control={control}
      error={errors[name]}
      inputSize="medium"
      blockWidth
      label="Maximum Invoice Amount ($) Chargeable to Credit Card *"
      placeholder="e.g. 5000"
      rules={{
        required: 'Max Invoice Amount is required',
        max: {
          value: 1000000,
          message: 'Max Invoice Amount must be less than or equal to 1000000',
        },
        min: {
          value: 0,
          message: 'Max Invoice Amount must be greater than or equal to 0',
        },
      }}
    />
  );
}
